module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-products/admin-products.component.scss
// module id = ./src/app/components/admin/admin-products/admin-products.component.scss
// module chunks = main